import { Component, Module } from "app/decorators";

import _ from "lodash";
import angular from "angular";

import tpl from "./hit-percentage.button.html";

@Module({
  name: "app.directives.hit-percentage.button.component",
})
@Component({
  selector: "blnd-hit-percentage-button",
  template: tpl,
  bindings: {
    ngModel: "=",
    ngDisabled: "=?",
    type: "@",
    multiple: "=?",
    table: "<",
  },
})
export default class C {
  constructor($growl, $element, R, Modal, Config) {
    "ngInject";

    this.$growl = $growl;
    this.$element = $element;

    if (_.indexOf(["order", "ticket"], this.type) === -1) {
      throw "Invalid type for Hit Percentages";
    }
    this.R = R;
    this.Modal = Modal;
    this.multiple = this.multiple || false;
    this.hitPercentages = Config.$config[this.type].hit_percentages;
    this.hitPercentageMap = _.fromPairs(this.hitPercentages);
    this.ngDisabled = this.ngDisabled || false;
    this.loading = false;
  }

  $onDestroy() {
    this.$element.remove();
    this.$element = null;
  }

  changeHitPercentage(newHitPercentage) {
    this.loading = true;
    this.ngModel
      .patch({ hit_percentage: newHitPercentage })
      .then(
        (response) => {
          angular.extend(this.ngModel, response);
          this.$growl.success("Status Changed!");
        },
        (response) => {
          if (response.status === 500) {
            this.$growl.error(response.data.detail);
          }
        }
      )
      .finally(() => (this.loading = false));
  }
}



// WEBPACK FOOTER //
// ./src/app/directives/hit-percentage.button/component.js